import React, { useState } from 'react';

import Feedback from './feedback.component';
import { IFeedbackContainerProps } from './feedback.definition';
import { postHttp } from '@Utils/useHttp';

/**
 * Container component for Feedback, manages form state and handles submission logic.
 *
 * @param {IFeedbackContainerProps} props - Props for the Feedback container
 * @returns {JSX.Element} Feedback component with container props and functions
 */
export const FeedbackContainer = (props: IFeedbackContainerProps) => {
	const [showForm, setShowForm] = useState(false);
	const [onSuccess, setOnSuccess] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [fields, setFields] = useState<{ feedback: string }>({ feedback: '' });

	/**
	 * Handles field value changes in the feedback form.
	 *
	 * @param {string} name - Field name
	 * @param {string} val - Field value
	 */
	const onChange = (name: string, val: string) => {
		setFields((prevFields) => ({
			...prevFields,
			[name]: val
		}));
	};

	/**
	 * Submits the feedback form and shows notification based on result.
	 *
	 * @returns {Promise<void>} Resolves when submission is complete
	 */
	const onSubmit = async () => {
		setIsLoading(true);

		const response = await postHttp('api/feedback', fields);

		setIsLoading(false);

		if (response.status) {
			setOnSuccess(true);
		} else {
			onChange('feedback', '');
			window.App.Util.message('Der er desværre en teknisk fejl i øjeblikket. Prøv igen senere. Vi beklager ulejligheden.', false);
		}
	};

	/**
	 * Returns props to be passed to the Feedback component.
	 *
	 * @returns {object} Props for Feedback component
	 */
	const containerProps = () => {
		return {
			...props,
			showForm,
			isLoading,
			fields,
			onSuccess
		};
	};

	const containerFunctions = {
		setShowForm,
		setOnSuccess,
		onSubmit,
		onChange
	};

	return (
		<Feedback
			{ ...containerProps() }
			{ ...containerFunctions }
		/>
	);
};

export default FeedbackContainer;